export var ErrorKey;
(function (ErrorKey) {
    ErrorKey["missing"] = "missing";
    ErrorKey["noLocationAndProduct"] = "noLocationAndProduct";
    ErrorKey["invalidDate"] = "invalidDate";
    ErrorKey["invalidFromMany"] = "invalidFromMany";
    ErrorKey["unequal"] = "unequal";
    ErrorKey["datesWrongOrder"] = "datesWrongOrder";
    ErrorKey["invalid"] = "invalid";
    ErrorKey["locationAndProductProvided"] = "locationAndProductProvided";
    ErrorKey["missingInputKey"] = "missingInputKey";
    ErrorKey["invalidType"] = "invalidType";
    ErrorKey["invalidActivityData"] = "invalidActivityData";
    ErrorKey["insideClosedPeriod"] = "insideClosedPeriod";
})(ErrorKey || (ErrorKey = {}));
//# sourceMappingURL=BulkImport.js.map